import React, { useState } from 'react'

import { PlusCircle as PlusCircleIcon } from 'react-feather'

import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
} from '@material-ui/core'
import Typography from '@material-ui/core/Typography'

import { useParams, useHistory } from 'react-router-dom'

import {
  Container,
  ContentHeader,
  LoadingFeedback,
  Page,
  Permitted,
} from 'components'

import { KpiForm } from './components'
import KpiMetricsTable from './components/KpiMetrics'

import * as service from 'service'
import constants from 'constants/index'
import { routes } from 'Routes'

import useFetch from 'hooks/useFetch'

const KpiEdit = () => {
  const [expanded, setExpanded] = useState(false)
  const [openMetricModal, setOpenMetricModal] = useState(false)
  const { monitoringManagementKpiId } = useParams()

  const history = useHistory()

  const { response, isLoading, refresh } = useFetch(
    service.dponet.monitoringManagementKpi.show,
    { monitoringManagementKpiId },
    [monitoringManagementKpiId],
  )

  const monitoringManagementKpi = response?.data?.monitoringManagementKpi

  const handleOpenMetricModal = () => {
    setOpenMetricModal(true)
  }

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <Page title="Edição de Projeto - Monitoramento">
      <LoadingFeedback open={isLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="KPI" />
        <Accordion
          expanded={expanded === 'panel-kpi'}
          onChange={handleAccordionChange('panel-kpi')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel-kpi-content"
            id="panel-kpi-header"
          >
            <Typography
              style={{
                fontWeight: '700',
              }}
            >
              Clique aqui para editar o KPI
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <KpiForm
              monitoringManagementKpi={monitoringManagementKpi}
              refresh={refresh}
            />
          </AccordionDetails>
        </Accordion>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mt={5}
          mb={2}
        >
          <Typography
            style={{ fontWeight: 600 }}
            variant="h3"
            color="textPrimary"
          >
            Métricas
          </Typography>
          <Permitted
            tag={constants.permissions.MONITORING_MANAGEMENT_KPI.MANAGE}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={handleOpenMetricModal}
              disabled={isLoading}
            >
              Criar Métrica
            </Button>
          </Permitted>
        </Box>
        <KpiMetricsTable
          monitoringManagementKpi={monitoringManagementKpi}
          handleOpenMetricModal={handleOpenMetricModal}
          openMetricModal={openMetricModal}
          setOpenMetricModal={setOpenMetricModal}
        />
        <Box ml={2} mt={2} display="flex" justifyContent="flex-end">
          <Box pr={1}>
            <Button
              type="button"
              variant="outlined"
              onClick={() => history.push(routes.kpi.all)}
            >
              Voltar
            </Button>
          </Box>
        </Box>
      </Container>
    </Page>
  )
}

export default KpiEdit
